import { render } from "./PageSwitch.vue?vue&type=template&id=456ac2e0&scoped=true"
import script from "./PageSwitch.vue?vue&type=script&lang=js"
export * from "./PageSwitch.vue?vue&type=script&lang=js"

import "./PageSwitch.vue?vue&type=style&index=0&id=456ac2e0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-456ac2e0"]])

export default __exports__